import React, { useEffect, lazy, Suspense } from 'react';
import './App.css';
import { registerWebMcpTools } from './webmcp';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
const AboutPage = lazy(() => import('./pages/AboutPage'));
const OurStoryPage = lazy(() => import('./pages/OurStoryPage'));
const ServicesPage = lazy(() => import('./pages/ServicesPage'));
const ServiceDetailPage = lazy(() => import('./pages/ServiceDetailPage'));
const TeamPage = lazy(() => import('./pages/TeamPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const BlogPage = lazy(() => import('./pages/BlogPage'));
const BlogPostPage = lazy(() => import('./pages/BlogPostPage'));
const FaqPage = lazy(() => import('./pages/FaqPage'));
const Toaster = lazy(() => import('./components/ui/toaster').then((m) => ({ default: m.Toaster })));

const BOOKING_URL = 'https://book2.getweave.com/2bc948fe-32de-4a55-8b90-fa5b2ffc32d6/request-appointment?source=WEBSITE';
const CONVERSION_SEND_TO = 'AW-18485772332/Ai6BCPHpr54dEKyA2u5E';
const CONVERSION_FLAG = 'bw_book_conversion_sent';

function trackBookingConversion() {
  if (sessionStorage.getItem(CONVERSION_FLAG)) return;
  sessionStorage.setItem(CONVERSION_FLAG, '1');
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', { send_to: CONVERSION_SEND_TO });
  }
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track/booking-click`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ path: window.location.pathname }),
    keepalive: true
  }).catch(() => {});
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => { registerWebMcpTools(); }, []);
  const openBooking = () => {
    trackBookingConversion();
    window.open(BOOKING_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-[#0B0B0B] focus:text-[#FAF7F2] focus:px-4 focus:py-2 focus:text-sm"
        >
          Skip to main content
        </a>
        <Navbar onBookClick={openBooking} />
        <main id="main-content" role="main">
          <Suspense fallback={<div className="min-h-screen bg-[#FAF7F2]" />}>
          <Routes>
            <Route path="/" element={<HomePage onBookClick={openBooking} />} />
            <Route path="/about" element={<AboutPage onBookClick={openBooking} />} />
            <Route path="/about/our-story" element={<OurStoryPage onBookClick={openBooking} />} />
            <Route path="/services" element={<ServicesPage onBookClick={openBooking} />} />
            <Route path="/services/:slug" element={<ServiceDetailPage onBookClick={openBooking} />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage onBookClick={openBooking} />} />
            <Route path="/faq" element={<FaqPage onBookClick={openBooking} />} />
          </Routes>
          </Suspense>
        </main>
        <Footer />
        <Suspense fallback={null}><Toaster /></Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
